<template>
    <v-row>
        <v-col cols="12">
            <v-radio-group column v-model="coSelection" @change="updateActiveCountryId">
                <v-radio
                    v-for="country in avCountries"
                    :key = "country.id"
                    :label= "country.title"
                    color="primary"
                    :value="country.id"
                ></v-radio>
            </v-radio-group>
        </v-col>
    </v-row>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name: "Countries",

        data: () => ({
            coSelection: 190
        }),

        computed: {
            ...mapGetters({
                avCountries: 'countries/avCountries'
            })
        },

        methods: {
            ...mapMutations({
                updateActiveCountryId: 'countries/updateActiveCountry'
            })
        },

        created() {
            //this.$store.dispatch('countries/retrieveAvCountries')
        },


    };
</script>
